import React from "react";
import { Box, Typography, Button } from "@mui/material";
import "./ContentHeader.css";

const ContentHeader = ({ title, buttonLabel, onButtonClick }) => {
    return (
        <Box className="content-header">
            <Typography variant="h4" className="content-header-title">
                {title}
            </Typography>
            {buttonLabel && onButtonClick && (
                <Button 
                    className="content-header-button secondary-button" 
                    onClick={onButtonClick}
                >
                    {buttonLabel}
                </Button>
            )}
        </Box>
    );
};

export default ContentHeader;
